<div class="more-info-title">
  <div class="more-info-title__name">{{ title }}</div>
  <div class="more-info-title__line"></div>
</div>
